import { render } from "./StatView.vue?vue&type=template&id=3bf1985a"
import script from "./StatView.vue?vue&type=script&lang=js"
export * from "./StatView.vue?vue&type=script&lang=js"

import "./StatView.vue?vue&type=style&index=0&id=3bf1985a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__